interface Props {
  name: string;
  incidents: number;
  changes: number;
}

const Customer = ({ name, incidents, changes }: Props) => {
  return (
    <div className="bg-gray-200 rounded-lg flex justify-between p-2 m-3">
      <p className="mt-auto mb-auto ml-8 text-l text-left w-1/2">{name}</p>
      <div className="text-l w-1/2 text-center mt-auto mb-auto flex flex-row justify-evenly">
        <p className="w-1/2">{incidents}</p>
        <p className="w-1/2">{changes}</p>
      </div>
    </div>
  );
};

export default Customer;
